import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { SalaryApprovalStatusItem } from "services/SalaryAdvance";

import Paths from "./paths";
import * as Types from "./types";

export const salaryPaymentListService = (
  params: Types.SalaryPaymentListRequest
) =>
  RestAPIClient.call<Types.SalaryPaymentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const salaryPaymentListShortService = (
  params: Types.SalaryPaymentListRequest
) =>
  RestAPIClient.call<Types.SalaryPaymentListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const salaryPaymentCreateService = (
  params: Types.SalaryPaymentCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const salaryPaymentUpdateService = (
  params: Types.SalaryPaymentUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, "id"),
  });

export const salaryPaymentDetailService = (id: string) =>
  RestAPIClient.call<Types.SalaryPaymentDetail>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{id}", String(id)),
    config: {
      requireAuthentication: true,
    },
  });

export const salaryPaymentDeleteService = (id: string) =>
  RestAPIClient.call<Types.SalaryPaymentDetail>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Detail.replace("{id}", String(id)),
    config: {
      requireAuthentication: true,
    },
  });

export const salaryPaymentBankTransferExportService = (params: {
  page: number | null;
  limit: number | null;
  salaryPaymentId: string | null;
  bankCode?: string | null;
}) =>
  RestAPIClient.call<Types.SalaryPaymentBankTransferExportResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.BankTransfer,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const salaryPaymentDetailEmployeeService = (params: {
  id: string;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
  empCode?: string | null;
}) =>
  RestAPIClient.call<Types.SalaryPaymentListEmployeeResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.DetailEmployee.replace("{id}", String(params.id)),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const salaryPaymentApprovalStatusService = (params: {
  year?: number | null;
  month?: number | null;
  templateId?: string | null;
  templatePeriod?: number | null;
  salaryPaymentId?: string | null;
  cycleId?: string | null;
}) =>
  RestAPIClient.call<SalaryApprovalStatusItem>({
    method: HTTPRequestMethods.GET,
    url: Paths.ApprovalStatus,
    config: {
      requireAuthentication: true,
      params,
    },
  });
